import { render, staticRenderFns } from "./DelegateArrival.vue?vue&type=template&id=2f341431"
import script from "./DelegateArrival.vue?vue&type=script&lang=js"
export * from "./DelegateArrival.vue?vue&type=script&lang=js"
import style0 from "./DelegateArrival.vue?vue&type=style&index=0&id=2f341431&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports